/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateTaskRequestDto,
  ListTasksResponseDto,
  TaskResponseDto,
  UpdateTaskRequestDto,
} from '../models/index';
import {
    CreateTaskRequestDtoFromJSON,
    CreateTaskRequestDtoToJSON,
    ListTasksResponseDtoFromJSON,
    ListTasksResponseDtoToJSON,
    TaskResponseDtoFromJSON,
    TaskResponseDtoToJSON,
    UpdateTaskRequestDtoFromJSON,
    UpdateTaskRequestDtoToJSON,
} from '../models/index';

export interface TaskControllerCreateRequest {
    createTaskRequestDto: CreateTaskRequestDto;
}

export interface TaskControllerFindByIdRequest {
    id: string;
}

export interface TaskControllerUpdateRequest {
    id: string;
    updateTaskRequestDto: UpdateTaskRequestDto;
}

/**
 * 
 */
export class PreventiveMaintenanceTasksApi extends runtime.BaseAPI {

    /**
     */
    async taskControllerCreateRaw(requestParameters: TaskControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TaskResponseDto>> {
        if (requestParameters['createTaskRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createTaskRequestDto',
                'Required parameter "createTaskRequestDto" was null or undefined when calling taskControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/tasks`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateTaskRequestDtoToJSON(requestParameters['createTaskRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TaskResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async taskControllerCreate(requestParameters: TaskControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TaskResponseDto> {
        const response = await this.taskControllerCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async taskControllerFindAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListTasksResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/tasks`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListTasksResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async taskControllerFindAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListTasksResponseDto> {
        const response = await this.taskControllerFindAllRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async taskControllerFindByIdRaw(requestParameters: TaskControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TaskResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling taskControllerFindById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/tasks/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TaskResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async taskControllerFindById(requestParameters: TaskControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TaskResponseDto> {
        const response = await this.taskControllerFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async taskControllerUpdateRaw(requestParameters: TaskControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TaskResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling taskControllerUpdate().'
            );
        }

        if (requestParameters['updateTaskRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateTaskRequestDto',
                'Required parameter "updateTaskRequestDto" was null or undefined when calling taskControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/tasks/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTaskRequestDtoToJSON(requestParameters['updateTaskRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TaskResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async taskControllerUpdate(requestParameters: TaskControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TaskResponseDto> {
        const response = await this.taskControllerUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
